import {
  DOWNLOAD_REPORT_SEARCH, DOWNLOAD_PLAN_SEARCH,
  DOWNLOAD_REPORT, DOWNLOAD_PLAN, DOWNLOAD_CANCEL,
  DOWNLOAD_SEARCH_SUCCESS, DOWNLOAD_SUCCESS, DOWNLOAD_CANCEL_SUCCESS,
  DOWNLOAD_SEARCH_FAILURE, DOWNLOAD_FAILURE, DOWNLOAD_CANCEL_FAILURE,
  DOWNLOAD_MSG_ALERT, DOWNLOAD_NOTIFY_CLEAR
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    notify: ''
  },

  getters: {
    /** 通知 */
    downloadNotify: state => {
      return state.notify
    }
  },

  actions: {
    [DOWNLOAD_REPORT_SEARCH] ({dispatch, state, commit}, params) {
      if (!(params.data && params.callback)) {
        throw new Error()
      }

      dispatch('apiGet', {url: '/zipdown/search_report', data: params.data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOWNLOAD_SEARCH_FAILURE, res.data)
            } else {
              commit(DOWNLOAD_SEARCH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [DOWNLOAD_PLAN_SEARCH] ({dispatch, state, commit}, params) {
      if (!(params.data && params.callback)) {
        throw new Error()
      }

      dispatch('apiGet', {url: '/zipdown/search_plan', data: params.data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOWNLOAD_SEARCH_FAILURE, res.data)
            } else {
              commit(DOWNLOAD_SEARCH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [DOWNLOAD_REPORT] ({dispatch, state, commit}, params) {
      var loadparams = true
      if (!(params.data && params.callback)) {
        throw new Error()
      }
      if ('loadparams' in params) {
        loadparams = params.loadparams
      }
      var url = '/zipdown/' + (params.mode === 'zip' ? 'download_report_zip' : 'download_report_pdf')

      dispatch('apiPost', {url: url, data: params.data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOWNLOAD_FAILURE, res.data)
            } else {
              commit(DOWNLOAD_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [DOWNLOAD_PLAN] ({dispatch, state, commit}, params) {
      if (!(params.data && params.callback)) {
        throw new Error()
      }
      var url = '/zipdown/' + (params.mode === 'zip' ? 'download_plan_zip' : 'download_plan_pdf')

      dispatch('apiPost', {url: url, data: params.data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(DOWNLOAD_FAILURE, res.data)
            } else {
              commit(DOWNLOAD_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [DOWNLOAD_CANCEL] ({dispatch, state, commit}, params) {
      var loadparams = true
      if (!(params.data && params.callback)) {
        throw new Error()
      }
      if ('loadparams' in params) {
        loadparams = params.loadparams
      }
      setTimeout(() => {
        dispatch('apiGet', {url: '/zipdown/cancel', data: params.data, loadparams: loadparams})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(DOWNLOAD_CANCEL_FAILURE, res.data)
              } else {
                commit(DOWNLOAD_CANCEL_SUCCESS, {
                  data: res.data,
                  callback: params.callback
                })
              }
            }
          })
          .catch(error => {
            throw error
          })
      }, 5000)
    },
    [DOWNLOAD_MSG_ALERT] ({state, commit}, msg) {
      commit(DOWNLOAD_MSG_ALERT, msg)
    },
    [DOWNLOAD_NOTIFY_CLEAR] ({state, commit}, sleep = constant.notifyShowTime.normal) {
      setTimeout(() => {
        commit(DOWNLOAD_NOTIFY_CLEAR)
      }, sleep)
    }
  },

  mutations: {
    [DOWNLOAD_SEARCH_FAILURE] (state, data) {
      console.log('DOWNLOAD_SEARCH_FAILURE')
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [DOWNLOAD_SEARCH_SUCCESS] (state, data) {
      console.log('DOWNLOAD_SEARCH_SUCCESS')
      data.callback(data.data)
    },
    [DOWNLOAD_FAILURE] (state, data) {
      console.log('DOWNLOAD_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [DOWNLOAD_SUCCESS] (state, data) {
      console.log('DOWNLOAD_SUCCESS')
      data.callback(data.data)
    },
    [DOWNLOAD_CANCEL_FAILURE] (state, data) {
      console.log('DOWNLOAD_CANCEL_FAILURE')
      state.notify = {message_i18n: 'messages.delete.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [DOWNLOAD_CANCEL_SUCCESS] (state, data) {
      console.log('DOWNLOAD_CANCEL_SUCCESS')
      data.callback()
    },
    /** メッセージ表示用 */
    [DOWNLOAD_MSG_ALERT] (state, msg) {
      console.log('DOWNLOAD_MSG_ALERT')
      state.notify = msg
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [DOWNLOAD_NOTIFY_CLEAR] (state) {
      state.notify = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/print.js